import { useCallback, useEffect, useRef, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import {
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Grid,
  List,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";
import { InsertDriveFile, Delete } from "@mui/icons-material";
import UtilsFncs from "utils/UtilsFncs";

const useStyles = makeStyles({
  dropzone: {
    padding: "2rem 2rem 1rem",
    backgroundColor: "#fff",
    border: "1px dashed #dee2e6",
    borderRadius: ".375rem",
    textAlign: "center",
    color: "#8898aa",
    cursor: "pointer",
  },
});

const FilesList = ({ files, removeFileFromList, disabled, multiple }) => {
  return (
    <List>
      <Grid container spacing={2}>
        {files?.map((file, index) => {
          return (
            <Grid item xs={12} lg={multiple ? 6 : 12} key={index}>
              <ListItem style={{ display: "flex", alignItems: "center" }}>
                <ListItemAvatar>
                  <InsertDriveFile fontSize="small" />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    file.name.length > 20
                      ? file.name.substring(0, 20) +
                        "..." +
                        file.name.split(".")[1]
                      : file.name
                  }
                  primaryTypographyProps={{
                    variant: "caption",
                    color: "textPrimary",
                  }}
                  secondary={UtilsFncs.GetFileSize(file)}
                  secondaryTypographyProps={{
                    variant: "caption",
                    color: "textPrimary",
                  }}
                />
                <ListItemSecondaryAction>
                  <Tooltip title="Remover arquivo">
                    <IconButton
                      onClick={() => removeFileFromList(index)}
                      disabled={disabled}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </ListItemSecondaryAction>
              </ListItem>
            </Grid>
          );
        })}
      </Grid>
    </List>
  );
};

export default function UploadFile({
  multiple = false,
  accept = null,
  message = "Selecione um arquivo ou arraste aqui",
  validator,
  onChangeFiles,
  disabled,
}) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const onChangeFilesRef = useRef(onChangeFiles);

  useEffect(() => {
    onChangeFilesRef.current = onChangeFiles;
  }, [onChangeFiles]);

  const onDrop = useCallback((acceptedFiles) => {
    setFiles((prev) => [...prev, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    accept,
    validator,
    onDrop,
  });

  useEffect(() => {
    if (typeof onChangeFilesRef.current === "function") {
      onChangeFilesRef.current(files);
    }
  }, [files]);

  const removeFileFromList = useCallback(
    (position) => {
      const filesToRemove = files;

      filesToRemove.splice(position, 1);

      setFiles([...filesToRemove]);
    },
    [files]
  );

  const showDropzone = multiple || files.length === 0;

  return (
    <>
      {showDropzone && (
        <div {...getRootProps({ className: classes.dropzone })}>
          <input {...getInputProps()} disabled={disabled} />
          <p>{message}</p>
        </div>
      )}
      {files.length > 0 && (
        <FilesList
          files={files}
          removeFileFromList={removeFileFromList}
          disabled={disabled}
          multiple={multiple}
        />
      )}
    </>
  );
}
